import { createContext } from "react";
import { initialState } from "./initalState";

export default createContext(initialState);
